import React from "react";
import PropTypes from "prop-types";
import "./ThinkingOrb.scss";

/**
 * ThinkingOrb - стильный светящийся AI-индикатор вычислений и загрузки.
 * Поддерживает размеры: 'sm' (для кнопок и плашек), 'md' (для модалок), 'lg' (для экранов загрузки).
 */
const ThinkingOrb = ({ size = "md", text = "", className = "", showRing = true }) => {
  return (
    <div className={`thinking-orb-container orb-${size} ${className}`}>
      <div className="orb-body-wrapper">
        {showRing && <div className="orb-cosmic-ring" />}
        <div className="thinking-orb-sphere" />
      </div>
      {text && <div className="orb-caption-text">{text}</div>}
    </div>
  );
};

ThinkingOrb.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  text: PropTypes.string,
  className: PropTypes.string,
  showRing: PropTypes.bool,
};

export default ThinkingOrb;